module.exports = __webpack_public_path__ + "static/media/shareBg.7ae15901.png";